// TechnologyConetnt

import React, { FC, useCallback } from 'react';
import styles from './TechnologyConetnt.module.scss';
import VideoPlayer from '../../components/VideoPlayer';
import { Image } from '../../components/Image';
import Comma from '../../components/Comma';
import AIToolList from './AIToolList';
import AIProductIntro from './AIProductIntro';
import TechProductCard from './TechProductCard';
import { Props } from './type';

export interface DataType {
  [key: string]: string;
}

const TechnologyConetnt: FC<Props> = (props) => {
  const { manMachineData, scientificData, productCardDataArr, productIntroDataArr, toolData } = props;

  // todo pm要求一直播放，不允许暂停，现用hack处理办法，如果暂停就业务主动在触发继续播放
  const onPause = useCallback((player: any) => {
    player?.play();
  }, []);

  return (
    <section className={styles['technology-conetnt-box']}>
      {/* AI 产品介绍模块 */}
      {productIntroDataArr.map((data, index) => (
        <AIProductIntro key={index} {...data} />
      ))}

      {/* AI工具列表模块 */}
      <AIToolList {...toolData} />

      {/* 技术产品卡片示例 - 无人机 */}
      <div className={styles['technology-conetnt-uav-car']}>
        {productCardDataArr.map((data, index) => (
          <TechProductCard key={index} {...data} />
        ))}
      </div>

      {/* 人机城相关模块 */}
      <div className="px-5 pt-[50px] lg:pt-[100px]">
        <div className={styles['content-item-wrap']}>
          {/* 人机城标题 */}
          <div className={styles['content-item-title']}>
            <div className={styles['content-item-title-item']}>{manMachineData.titleMain}</div>
            {manMachineData.titleVice && (
              <span className={styles['comma-box']}>
                <Comma />
              </span>
            )}

            <div className={styles['content-item-title-item']}>{manMachineData.titleVice}</div>
          </div>
          {/* 人机城介绍信息 */}
          <div className={styles['content-item-intro']}>
            <p>{manMachineData.intro1}</p>
            <p>{manMachineData.intro2}</p>
          </div>

          {/* 人机城相关视频 */}
          <div className={styles['video-box']}>
            <div className={styles['video-wrap']}>
              <VideoPlayer
                onPause={onPause}
                source={manMachineData.relevantVideo1}
                poster={manMachineData.relevantPoster1}
                autoplay
                hideControl
              />
            </div>
            <div className={styles['video-wrap']}>
              <VideoPlayer
                onPause={onPause}
                source={manMachineData.relevantVideo2}
                poster={manMachineData.relevantPoster2}
                autoplay
                hideControl
              />
            </div>
          </div>
        </div>
      </div>

      {/* 科研合作相关模块 */}
      <div className="px-5 pt-[50px] lg:pt-[100px]">
        <div className={styles['content-item-wrap']}>
          {/* 科研合作标题 */}
          <div className={styles['content-item-title']}>
            <div className={styles['content-item-title-item']}>{scientificData.titleMain}</div>
            {scientificData.titleVice && (
              <span className={styles['comma-box']}>
                <Comma />
              </span>
            )}
            <div className={styles['content-item-title-item']}>{scientificData.titleVice}</div>
          </div>
          {/* 科研合作介绍信息 */}
          <div className={styles['content-item-intro']}>
            <span>{scientificData.intro1}</span>
            <span>{scientificData.intro2}</span>
          </div>
          <div className="relative h-[40vw] max-h-[520px] overflow-hidden  rounded-lg lg:rounded-2xl">
            <Image
              src={scientificData.imgConfig.imgUrl}
              layout="responsive"
              width={scientificData.imgConfig.width}
              height={scientificData.imgConfig.height}
              objectFit="cover"
              compressOptions={{ quality: 80 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
TechnologyConetnt.defaultProps = {};

TechnologyConetnt.displayName = 'TechnologyConetnt';
export default TechnologyConetnt;
